(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wpc-menu-guides-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const sessions = new WeakMap();
    function closeGuide(drawer, restoreFocus = true) {
      const session = sessions.get(drawer);
      if (!session) return;
      session.panel.classList.remove('subchild_slide_active', 'subchild_slide_closing');
      session.panel.setAttribute('aria-hidden', 'true');
      session.panel.inert = true;
      session.trigger.setAttribute('aria-expanded', 'false');
      session.covered.forEach(element => { element.inert = false; });
      sessions.delete(drawer);
      if (restoreFocus && drawer.open) session.trigger.focus({ preventScroll: true });
    }
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-wpc-guide-open]');
      if (trigger) {
        const drawer = trigger.closest('details');
        const panel = document.getElementById(trigger.dataset.wpcGuideOpen);
        if (!drawer || !panel || !drawer.contains(panel)) return;
        event.preventDefault();
        closeGuide(drawer, false);
        const content = panel.parentElement;
        const covered = Array.from(content.children).filter(element => (
          element !== panel &&
          !element.classList.contains('drawer__button-close') &&
          !element.inert
        ));
        content.querySelectorAll('.subchild_slide_active').forEach(element => {
          element.classList.remove('subchild_slide_active', 'subchild_slide_closing');
        });
        covered.forEach(element => { element.inert = true; });
        trigger.setAttribute('aria-expanded', 'true');
        panel.inert = false;
        panel.setAttribute('aria-hidden', 'false');
        panel.scrollTop = 0;
        panel.classList.add('subchild_slide_active');
        sessions.set(drawer, { panel, trigger, covered });
        panel.querySelector('[data-wpc-guide-back]').focus({ preventScroll: true });
        return;
      }
      const back = event.target.closest('[data-wpc-guide-back]');
      if (back) closeGuide(back.closest('details'));
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const drawer = event.target.closest('details');
      if (!drawer || !sessions.has(drawer)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeGuide(drawer);
    }, true);
    document.addEventListener('toggle', event => {
      if (event.target instanceof HTMLDetailsElement && !event.target.open) {
        closeGuide(event.target, false);
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
